export default "__VITE_ASSET__B0i9o07A__"